import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LifeMartHookPreview from "@/pages/LifeMartHookPreview";

export const Route = createFileRoute("/lifemart/hook-preview")({
  head: () => seoHead("/lifemart/hook-preview"),
  component: LifeMartHookPreview,
});
